export default {
  '\x01': `
    [6,8]
     ++
     +++
     ++++
     +++++
     ++++
     +++
     ++
  `,
  '\x02': `
    [6,8]

     +++++
      +  +
         +
         +
     +++++

  `,
  '\x03': `
    [6,8]

     +   +
      + +
       +
      + +
     +   +

  `,
  '\x04': `
    [6,8]

      ++++
        ++
       + +
      +  +
     +

  `,
  '\x05': `
    [6,8]

       +
       +
     + + +
      +++
       +

  `,
}



// WEBPACK FOOTER //
// ./src/dot-fonts/special.js